import { Select, Space } from 'antd'
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { ConfigCard } from './styles'
import { updateTemplateType } from '~/states/modules/editTemplate'
import { useDispatch } from 'react-redux'

const SelectTemplate = ({
	initial_template,
	onTemplateChange,
	files,
	editor_text,
}) => {
	const dispatch = useDispatch()

	const [selectedValue, setSelectedValue] = useState(initial_template)
	const [loadInitialValue, setLoadInitialValue] = useState(false)
	const [areSelectsDisabled, setAreSelectsDisabled] = useState(false)

	if (!editor_text) {
		editor_text = ''
	}

	if (!loadInitialValue && initial_template) {
		onTemplateChange(initial_template)
		setLoadInitialValue(true)
	}

	const handleChangeTemplate = (value) => {
		setSelectedValue(value)
		onTemplateChange(value)
		dispatch(updateTemplateType(value))
	}

	useEffect(() => {
		const shouldDisableSelects =
			(selectedValue === '.docx' && files.length > 0) ||
			(selectedValue === '.pdf' && files.length > 0) ||
			(selectedValue === '.txt' && editor_text !== '')
		setAreSelectsDisabled(shouldDisableSelects)
	}, [selectedValue, files, editor_text])

	return (
		<ConfigCard title="Tipo do Modelo">
			<Space direction="horizontal">
				<Select
					placeholder="Tipo do Modelo"
					style={{ width: 150 }}
					onChange={handleChangeTemplate}
					value={selectedValue}
					options={[
						{ value: '.txt', label: 'Texto' },
						{ value: '.docx', label: 'Docx' },
						{ value: 'upload', label: 'Upload' },
						{ value: '.pdf', label: 'Pdf' },
					]}
					disabled={areSelectsDisabled}
				/>
			</Space>
		</ConfigCard>
	)
}

SelectTemplate.propTypes = {
	initial_template: PropTypes.string,
	onTemplateChange: PropTypes.func,
	files: PropTypes.array,
	editor_text: PropTypes.string,
}

export default SelectTemplate
